var _a;
import { Board, Size, } from "../../core";
export class RugbyBoard extends Board {
    constructor() {
        super(_a.size);
    }
    static reconstruct(tokens, drawings, lines, texts) {
        const board = new _a();
        this.hydrate(board, tokens, drawings, lines, texts);
        return board;
    }
}
_a = RugbyBoard;
RugbyBoard.sizeScale = 20 / 110;
RugbyBoard.size = new Size(110 * _a.sizeScale, 70 * _a.sizeScale);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicnVnYnktYm9hcmQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvc3BvcnRzL3J1Z2J5L3J1Z2J5LWJvYXJkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQ0wsS0FBSyxFQUtMLElBQUksR0FDTCxNQUFNLFlBQVksQ0FBQztBQUVwQixNQUFNLE9BQU8sVUFBVyxTQUFRLEtBQUs7SUFDbkM7UUFDRSxLQUFLLENBQUMsRUFBVSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ3pCLENBQUM7SUFNRCxNQUFNLENBQUMsV0FBVyxDQUNoQixNQUFnQyxFQUNoQyxRQUE0QixFQUM1QixLQUFzQixFQUN0QixLQUE4QjtRQUU5QixNQUFNLEtBQUssR0FBRyxJQUFJLEVBQVUsRUFBRSxDQUFDO1FBQy9CLElBQUksQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLE1BQU0sRUFBRSxRQUFRLEVBQUUsS0FBSyxFQUFFLEtBQUssQ0FBQyxDQUFDO1FBQ3BELE9BQU8sS0FBSyxDQUFDO0lBQ2YsQ0FBQzs7O0FBYnVCLG9CQUFTLEdBQUcsRUFBRSxHQUFHLEdBQUcsQUFBWCxDQUFZO0FBRTdCLGVBQUksR0FBRyxJQUFJLElBQUksQ0FBQyxHQUFHLEdBQUcsRUFBSSxDQUFDLFNBQVMsRUFBRSxFQUFFLEdBQUcsRUFBSSxDQUFDLFNBQVMsQ0FBQyxBQUF0RCxDQUF1RCJ9